var _ = require('underscore');

// check if value is valid integer
export function isInt(value) {
    if ((parseFloat(value) == parseInt(value)) && !_.isNaN(value)) {
        return true;
    }
    else {
        return false;
    }
}
